import { Route } from "react-router-dom";

import RequireAuth from "app/router/components/RequireAuth";
import AdminPermissions from "pages/members/AdminPermissions";
import AdminRegister from "pages/members/AdminRegister";
import MemberManager from "pages/members/MemberManager";

export function getMemberRoutes() {
  return (
    <Route path="/members">
      {/* 회원 영역 전체는 총학관리자 이상(auth≥3)만 접근 가능 */}
      <Route
        element={
          <RequireAuth
            minAuth={3}
            message="총학관리자 이상만 접근할 수 있습니다."
          />
        }
      >
        {/* 회원 조회는 총학관리자 이상(auth≥3) */}
        <Route path="memberManager" element={<MemberManager />} />
        {/* 회원 관리(권한 변경·삭제·관리자 등록)는 마스터관리자(auth 4) 전용 */}
        <Route
          element={
            <RequireAuth
              minAuth={4}
              message="마스터 관리자만 접근할 수 있습니다."
            />
          }
        >
          <Route path="adminPermissions" element={<AdminPermissions />} />
          <Route
            path="adminPermissions/adminRegister"
            element={<AdminRegister />}
          />
        </Route>
      </Route>
    </Route>
  );
}
